import { useState, useEffect } from 'react';
import axios from '../api/axios';

let cachedLogo = null;
let fetchPromise = null;

const useSystemLogo = () => {
  const [logoUrl, setLogoUrl] = useState(cachedLogo);

  useEffect(() => {
    if (cachedLogo) {
      setLogoUrl(cachedLogo);
      return;
    }

    if (!fetchPromise) {
      const serverUrl = window.__UMS_THEME__?.serverUrl || process.env.REACT_APP_SERVER_URLForLogo;
      fetchPromise = axios.get('/Universities/GetSystemLogo')
        .then(response => {
          if (response.data?.logo) {
            cachedLogo = `${serverUrl}/${response.data.logo}`;
          }
          return cachedLogo;
        })
        .catch(() => null);
    }

    fetchPromise.then(url => {
      if (url) setLogoUrl(url);
    });
  }, []);

  const fallbackLogo = `${process.env.PUBLIC_URL}/assets/brand/${window.__UMS_THEME__?.logoPath || process.env.REACT_APP_LOGO_PATH}`;

  return logoUrl || fallbackLogo;
};

export default useSystemLogo;
